import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Subscription } from "@/integrations/supabase/types/";
import { useState } from "react";

interface EditSubscriptionDialogProps {
  subscription: Subscription | null;
  onClose: () => void;
  onSave: (planName: string, price: string) => void;
}

export const EditSubscriptionDialog = ({
  subscription,
  onClose,
  onSave,
}: EditSubscriptionDialogProps) => {
  const [planName, setPlanName] = useState(subscription?.plan_name || "");
  // Show price in USD (base currency) for editing
  const [price, setPrice] = useState(subscription?.price.toString() || "");

  return (
    <Dialog open={!!subscription} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Edit Subscription</DialogTitle>
          <DialogDescription>
            Update subscription plan details and pricing
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="plan-name">Plan Name</Label>
            <Input
              id="plan-name"
              value={planName}
              onChange={(e) => setPlanName(e.target.value)}
              className="bg-background"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="price">Price (USD)</Label>
            <Input
              id="price"
              type="number"
              value={price}
              onChange={(e) => setPrice(e.target.value)}
              className="bg-background"
            />
          </div>
          <Button onClick={() => onSave(planName, price)} className="w-full">
            Save Changes
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
};